import { Gem } from "lucide-react";

/**
 * Uniform gem icon used across the whole app.
 * Bright violet body + soft glow so it "pops" on both light and dark themes.
 */
export const GemIcon = ({ size = 14, glow = true, className = "" }) => (
  <Gem
    size={size}
    strokeWidth={2}
    fill="#7C5CFF"
    className={`gem-icon ${className}`}
    style={{
      color: "#A78BFA",
      filter: glow ? "drop-shadow(0 0 6px rgba(167,139,250,0.85))" : "none",
    }}
  />
);

export default GemIcon;
